// extracted by mini-css-extract-plugin
export default {"page":"Dashboard_page__nGm-R","pageFadeIn":"Dashboard_pageFadeIn__rmCt8"};